<template>
  <VBusHelper
    :reactOn="$constants.EVENTS.BOOKMAKER.SELECT_BOOKMAKER_ID_TO_CHANGE"
    :handler="() => $refs.modal.show()"
  />
  <VBusHelper
    :reactOn="$constants.EVENTS.BOOKMAKER.REQUEST_BOOKMAKER_ID_CHANGE"
    :handler="() => $refs.modal.hide()"
  />
  <DialogComponent ref="modal" type="modal" noInnerPadding>
    <!-- REQUEST_BOOKMAKER_ID_CHANGE -->

    <div class="flex gap-4 flex-col bg-slate-100 p-5">
      <div class="text-2xl font-bold mb-5">Selectionnez l'id à changer</div>

      <div v-for="(bookmaker, key) in $constants.BOOKMAKER.INFOS">
        <div
          class="flex items-center gap-4 p-4 rounded-2xl border border-transparent cursor-pointer transition-all bg-white"
          @click="
            () => {
              $bus.emit(
                $constants.EVENTS.BOOKMAKER.REQUEST_BOOKMAKER_ID_CHANGE,
                {
                  bookmaker: key
                }
              );
            }
          "
        >
          <div
            class="min-w-14 w-14 h-14 object-cover bg-neutral-100 rounded-xl overflow-hidden"
          >
            <ImgComponent :src="bookmaker.logo" class="object-cover" />
          </div>

          <div class="flex flex-col grow">
            <div class="text-xl text-primary">
              {{ bookmaker.name }}
            </div>

            <div class="text-lg text-neutral-500 flex gap-3">
              {{ bookmaker.description }}
            </div>
          </div>

          <div class="min-w-4 w-4 h-4">
            <ColorImg
              src="/images/icons/right-arrow.svg"
              class="bg-primary-200"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </DialogComponent>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'BuyGiftCardForm'
});
</script>
